import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";

import {
  getCurrentUserParams,
  loginStudent,
  updateUserSoftEmail,
} from "../../../../Backend";
import { setUserCredentials } from "../../../../Reducer";
import { WebRoutes } from "../../../../Constants";
import { LocalStorage } from "../../../../Helpers";
import { BarcodeInfoModal, FormInput } from "../../../../Components";
import { hasValue, isValidEmail } from "../../../../Helpers/validations/common";

import "./StudentLoginPage.scss";
import { Authenticated, Authentication } from "../../../../Constants/TokenKeys";

const initUser = {
  adress: "",
  city: "",
  currentBarcode: "",
  showAdvice: false,
  country: "",
  customerId: "",
  email: "",
  endReturnDate: "",
  firstName: "",
  id: "",
  lastName: "",
  postalCode: "",
  preposition: "",
  role: 0,
  roleNames: [],
  schoolId: "",
  schoolName: "",
  schoolNumber: "",
  softEmail: "",
  startReturnDate: "",
  userName: "",
};

export function StudentLoginPage() {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [barcode, setBarcode] = useState("");
  const [postalCode, setPostalCode] = useState("");

  const [infoModalShow, setInfoModalShow] = useState(false);
  const [userData, setUserData] = useState(initUser);
  const [originalSoftEmail, setOriginalSoftEmail] = useState("");

  const [accesssToken, setAccessToken] = LocalStorage("accessToken");
  const [refreshToken, setRefreshToken] = LocalStorage("refreshToken");

  const [isFirstTime, setIsFirstTime] = useState(true);

  const [errorBarcode, setErrorBarcode] = useState(false);
  const [errorEmail, setErrorEmail] = useState(false);

  useEffect(() => {
    if (hasValue(userData.softEmail) && isValidEmail(userData.softEmail)) {
      setErrorEmail(false);
    } else {
      setErrorEmail(true);
    }
  }, [userData.softEmail]);

  const login = async () => {
    if (hasValue(barcode) && hasValue(postalCode)) {
      await loginStudent(barcode, postalCode);
      var data = await getCurrentUserParams();

      if (data.success) {
        const userData = {
          ...data.data,
        };

        setUserData(userData);
        setOriginalSoftEmail(userData.softEmail);
        setIsFirstTime(false);
      } else {
        setErrorBarcode(true);
        const delay = (ms) => new Promise((res) => setTimeout(res, ms));
        await delay(3000);
        setErrorBarcode(false);
      }
    }
  };

  const updateUserData = async () => {
    if (originalSoftEmail !== userData.softEmail) {
      if (errorEmail === false) {
        var data = await updateUserSoftEmail(userData.softEmail);
        if (data.success) {
          localStorage.setItem(Authentication, Authenticated);
          redirect();
        }
      }
    } else {
      localStorage.setItem(Authentication, Authenticated);
      redirect();
    }
  };

  const redirect = () => {
    dispatch(setUserCredentials(userData));

    if (userData.isEnabled) {
      navigate(WebRoutes.StudentHomePage);
    } else {
      navigate(WebRoutes.UserNotEnabled);
    }
  };

  const clearLogin = () => {
    setAccessToken("");
    setRefreshToken("");
    setBarcode("");
    setPostalCode("");
    dispatch(setUserCredentials(initUser));
    setIsFirstTime(true);
  };

  function handleCloseBtnOnClick() {
    navigate(WebRoutes.EntryPage);
  }

  return (
    <div className="studentLoginPage">
      <BarcodeInfoModal
        show={infoModalShow}
        onHide={() => setInfoModalShow(false)}
      />
      <div className="studentLoginPage-content">
        <div className="title-wrapper">
          <span className="title">{t("SignInStudent")}</span>
          <span
            className="close"
            onClick={handleCloseBtnOnClick}
          >
            close
          </span>
        </div>
        {isFirstTime ? (
          <div className="form-wrapper">
            <FormInput
              placeholder={t("LoginPagePlaceholder")}
              type="text"
              value={barcode ? barcode : ""}
              errorText={t("LoginPageBarcodeError")}
              change={(x) => {
                setBarcode(x.replace(/\D/g, "").trim());
              }}
              otherProperties={{
                maxLength: 7,
                minLength: 7,
              }}
            />
            <FormInput
              placeholder={t("PostalCodePlaceholder")}
              type="text"
              change={(x, e) => {
                let newPostalCode = e.target.value.trim().toUpperCase();
                if (newPostalCode.length !== 4) {
                  newPostalCode = newPostalCode.replace(
                    /^(\w{4})(?!\s)/,
                    "$1 "
                  );
                }
                setPostalCode(newPostalCode);
              }}
              otherProperties={{
                maxLength: 7,
                minLength: 7,
              }}
              value={postalCode ? postalCode : ""}
            />
            <div className="button-wrapper">
              <Button
                className="button"
                disabled={!hasValue(barcode) || !hasValue(postalCode)}
                onClick={() => {
                  login();
                }}
              >
                {t("Continue")}
              </Button>
            </div>

            <a
              className="inleverLink fstyle-light"
              onClick={() => setInfoModalShow(true)}
            >
              {t("LoginPageQuestion")}
            </a>

            {errorBarcode && (
              <span className="errors">{t("LoginPageBarcodeError")}</span>
            )}
          </div>
        ) : (
          <>
            <div className="form-wrapper">
              <div className="row">
                <span className="text">{t("ConfirmPageSubtitle")}</span>
              </div>
              <div className="column">
                <span className="label">{t("ConfirmPageName")}</span>
                <span className="value">{userData.firstName}</span>
              </div>
              {/* <div className="column">
                <span className="label">{t("ConfirmPageSurname")}</span>
                <span className="value">{userData.lastName}</span>
              </div> */}

              <div className="column">
                <span className="label">{t("ConfirmPageEmail")}</span>
                <FormInput
                  placeholder=""
                  type="text"
                  value={userData.softEmail}
                  error={errorEmail}
                  errorText={t("ConfirmPageEmailError")}
                  change={(x) =>
                    setUserData({ ...userData, softEmail: x.trim() })
                  }
                  update={() => updateUserData()}
                />
              </div>
              <div className="button-wrapper">
                <Button
                  className="button"
                  disabled={errorEmail}
                  onClick={() => updateUserData()}
                >
                  {t("ConfirmPageConfirmBtn")}
                </Button>
                <Button className="button-cancel" onClick={() => clearLogin()}>
                  {t("ConfirmPageReturnBtn")}
                </Button>
              </div>
            </div>
          </>
        )}
        <div className="iddink-logo">
          <img src="/InleverBlueIcon.svg" alt="image" />
          <img src="/InleverBlueLogo.svg" alt="image" />
        </div>
        <span className="sanomaCompanyText">{t("NotLoggedCompany")}</span>
      </div>
    </div>
  );
}
